import React, { useState, useEffect } from "react";
//CSS
import "../../../utils/Css/Marketing.css";
import "../../../utils/Css/Campagne.css";
//Link
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
//icons
import { FaFlag, FaEnvelope, FaComments, FaThumbsUp } from "react-icons/fa";
import Divider from "@material-ui/core/Divider";
//buttons
import { Card, Button, Modal } from "react-bootstrap";
//table
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import BootstrapTable from "react-bootstrap-table-next";
//pagination
import paginationFactory from "react-bootstrap-table2-paginator";
//date
import DateRangePicker from "react-bootstrap-daterangepicker";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt, faTimes } from "@fortawesome/free-solid-svg-icons";
import campagneReseauxSociauxService from "../../../services/MarketingService/CampagneReseauxSociauxService";
import campagneService from "../../../services/MarketingService/CampagneService";
import campagnePhysiqueService from "../../../services/MarketingService/CampagnePhysiqueService";
import campagneSMSService from "../../../services/MarketingService/CampagneSMSService";

import campagneEmailService from "../../../services/MarketingService/CampagnEmailService";
// services/MarketingService/CampagneEmailService";
import getCurrentUserId from "./../../../reduxSaga/sagas/requests/currentUserId";
import enumListService from "../../../services/MarketingService/EnumListService";

import Swal from "sweetalert2";
import Datetime from "react-datetime";

function PageCampagne() {
  const [data, setData] = useState([]);

  const [debutDate, setdebutDate] = useState(null);
  const [finDate, setfinDate] = useState(null);

  const [piecesJointesdata, setPiecesJointesdata] = useState([]);
  const [typesData, setTypesData] = useState([]);
  const [canalDiffusionsData, setCanalDiffusionsData] = useState([]);
  const [objectifsData, setObjectifsData] = useState([]);
  const [statutsData, setStatutsData] = useState([]);

  const [selectedCampagne, setSelectedCampagne] = useState(null);
  const [publicationDate, setpublicationDate] = useState(null);

  const [inputValue, setInputValue] = useState(null);
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [success, setSuccess] = useState(null);
  const [erreur, setErreur] = useState(null);
  const [showModalPhysique, setShowModalPhysique] = useState(false);
  const [showModalReseaux, setShowModalReseaux] = useState(false);

  // Fonction utilitaire pour extraire l'ID de l'utilisateur du token JWT
  const user = JSON.parse(localStorage.getItem("user"));
  // Récupérer l'ID de l'utilisateur connecté
  const userId = user?.token.idUser;
  // Récupérer le rôle de l'utilisateur connecté/*  */
  const userRoles = user?.token.nameRole;

  // methode pour sweetAlert : pour afficher le success de la modification de publication
  const handleSuccess = () => {
    Swal.fire({
      icon: "success",
      html: `<strong>${success}</strong>`,
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
    });
  };

  useEffect(() => {
    if (success) {
      handleSuccess();
    }
  }, [success]);

  useEffect(() => {
    if (erreur) {
      const timeoutId = setTimeout(() => {
        setErreur(null);
      }, 2000);
      return () => clearTimeout(timeoutId);
    }
  }, [erreur]);

  //edit campagne reseaux sociaux

  // Gérer l'édition de la Campagne
  const handleEditCampagneReseauxSociaux = (campagne) => {
    setSelectedCampagne(campagne);
    setShowModalReseaux(true);
    setFormData({
      nom: campagne.nom,
      objectif: campagne.objectif,
      contenu: campagne.contenu,
      canalDiffusion: campagne.canalDiffusion,
      type: campagne.type,
      cible: campagne.cible,
      publicationDate: campagne.publicationDate,
      PiecesJoints: campagne.PiecesJoints,
    });
  };

  // Gérer la soumission du formulaire d'édition de la campagne
  const handleUpdateCampagneReseauxSociaux = async (event) => {
    event.preventDefault();

    const {
      nom,
      contenu,
      canalDiffusion,
      type,
      cible,
      objectif,
      publicationDate,
      PiecesJoints,
    } = formData;

    if (nom === selectedCampagne.nom && contenu === selectedCampagne.contenu) {
      // Vérifier si les champs ont été modifiés
      setErreur(
        "Veuillez modifier au moins un champ avant de soumettre le formulaire."
      );
      return;
    }

    const updatedCampagne = { ...formData };
    if (!nom) {
      // Vérifier si le nom et le prénom sont renseignés
      setErreur("Veuillez renseigner tous les champs.");
      return;
    }

    // Mettre à jour la Campagne avec les nouvelles informations et les images
    const images = piecesJointesdata ? piecesJointesdata : null;
    campagneReseauxSociauxService
      .mettreAJourCampagneReseauxSociaux(
        updatedCampagne,
        images,
        selectedCampagne.id
      )
      .then(() => {
        const updatedData = data.map((campagne) =>
          campagne.id === selectedCampagne.id
            ? { ...campagne, ...updatedCampagne }
            : campagne
        );
        setData(updatedData);
        setShowModalReseaux(false);
        setSelectedCampagne(null);
        setPiecesJointesdata([]);

        setSuccess("Modification validée avec succès !");
      });
  };
  const handleCancelCampagneReseauxSociaux = () => {
    setShowModalReseaux(false);
    setSelectedCampagne(null);
  };

  // /.edit campagne reseaux sociaux

  // edit campagne physique

  //EditModal
  const [formData, setFormData] = useState({
    nom: "",
    objectif: "",
    debutDate: "",
    finDate: "",
    ville: "",
    rue: "",
    pays: "",
    PiecesJoints: "",
    budget: "",
  });

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  //debutDate
  const handledebutDateChange = (date) => {
    setdebutDate(date);
    setFormData({ ...formData, debutDate: date });
  };

  //finDate
  const handlefinDateChange = (date) => {
    setfinDate(date);
    setFormData({ ...formData, finDate: date });
  };

  // Gérer la sélection de fichiers joints
  const handlePieceJointeChange = (event) => {
    setPiecesJointesdata([...piecesJointesdata, event.target.files[0]]);
  };

  // Supprimer le dernier fichier joint de la liste
  const handleDeletePieceJointe = () => {
    // Create a copy of the piecesJointesdata array
    const newPiecesJointesData = [...piecesJointesdata];

    // Remove the last item from the array
    newPiecesJointesData.pop();

    // Update the state with the new array
    setPiecesJointesdata(newPiecesJointesData);
  };

  const handleEditCampagnePhysique = (campagne) => {
    setSelectedCampagne(campagne);
    setShowModalPhysique(true);
    setFormData({
      nom: campagne.nom,
      objectif: campagne.objectif,
      debutDate: campagne.debutDate,
      finDate: campagne.finDate,
      ville: campagne.ville,
      rue: campagne.rue,
      pays: campagne.pays,
      PiecesJoints: campagne.PiecesJoints,
      budget: campagne.budget,
    });
  };

  // Gérer la soumission du formulaire d'édition de la publication
  const handleUpdateCampagnePhysique = async (event) => {
    event.preventDefault();

    const {
      nom,
      objectif,
      debutDate,
      finDate,
      ville,
      rue,
      pays,
      PiecesJoints,
      budget,
    } = formData;

    if (nom === selectedCampagne.nom) {
      // Vérifier si les champs ont été modifiés
      setErreur(
        "Veuillez modifier au moins un champ avant de soumettre le formulaire."
      );
      return;
    }

    const updatedCampagne = { ...formData };
    if (!nom) {
      // Vérifier si le nom et le prénom sont renseignés
      setErreur("Veuillez renseigner tous les champs.");
      return;
    }

    // Mettre à jour la publication avec les nouvelles informations et les images
    const images = piecesJointesdata ? piecesJointesdata : null;
    campagnePhysiqueService
      .mettreAJourCampagnePhysique(updatedCampagne, images, selectedCampagne.id)
      .then(() => {
        const updatedData = data.map((campagne) =>
          campagne.id === selectedCampagne.id
            ? { ...campagne, ...updatedCampagne }
            : campagne
        );
        setData(updatedData);
        setShowModalPhysique(false);
        setSelectedCampagne(null);
        setPiecesJointesdata([]);
        setSuccess("Modification validée avec succès !");
        setErreur(null);
        handleSuccess();
      });
  };
  const handleCancelPhysique = () => {
    setShowModalPhysique(false);
    setSelectedCampagne(null);
  };

  // /.edit campagne physique

  // state for filter parameters
  const [filter, setFilter] = useState({
    nom: "",
    canalDiffusion: "",
    statut: "",
    startDate: "",
    endDate: "",
  });

  const handleExportCSVBackend = async () => {
    try {
      // Création d'un tableau pour stocker les données filtrées
      const filteredData = data.map(
        (item) => `${item.nom},${item.statut},${item.canalDiffusion}`
      );
      // Appel à l'API Spring Boot pour récupérer les données filtrées
      const response = await campagneService.Exportcsv(filteredData);

      // Création du contenu du fichier CSV

      const csvContent = `data:text/csv;charset=utf-8,${response.data}`;

      // Création d'un élément d'ancrage invisible pour télécharger le fichier
      const downloadLink = document.createElement("a");
      downloadLink.href = encodeURI(csvContent);
      downloadLink.download = "filtered_data.csv";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    } catch (error) {
      console.error(error);
    }
  };

  // Fonction pour exporter les données filtrées au format CSV
  const handleExportCSV = () => {
    const currentDateTime = new Date().toISOString().replace(/[-:.]/g, "");
    const headerValue = "Nom,Type,Canal de diffusion";
    const csvData = data.map(
      (item) => `${item.nom},${item.type},${item.canalDiffusion}`
    );
    const csvContent = `${headerValue}\n${csvData.join("\n")}`;
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = `Campagne_Reseaux_Sociaux_${currentDateTime}.csv`;
    link.click();
  };

  //Delete modal
  // Gérer les changements de valeur dans l'entrée
  const handleInputChangeDelete = (event) => {
    setInputValue(event.target.value);

    // Désactiver le bouton de suppression si l'entrée est vide ou différente de "DELETE"
    if (event.target.value !== "DELETE") {
      setButtonDisabled(true);
    } else {
      setButtonDisabled(false);
    }
  };
  //DeleteModal
  const [show, setShow] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const handleClose = () => setShow(false);

  const handleDeleteCampagne = (row) => {
    setSelectedRow(row);
    setShow(true);
  };

  const handleConfirmDelete = async () => {
    try {
      if (selectedRow.canalDiffusion === "Email") {
        await campagneEmailService.supprimerCampagneEmail(selectedRow.id);
      } else if (
        ["Facebook", "Linkedin", "Instagram"].includes(
          selectedRow.canalDiffusion
        )
      ) {
        await campagneReseauxSociauxService.supprimerCampagneReseauxSociaux(
          selectedRow.id
        );
      } else if (selectedRow.canalDiffusion === "SMS") {
        await campagneSMSService.supprimerCampagneSMS(selectedRow.id);
      } else if (selectedRow.canalDiffusion === "Physique") {
        await campagnePhysiqueService.supprimerCampagnePhysique(selectedRow.id);
      }
      const newData = data.filter((item) => item.id !== selectedRow.id);
      setData(newData);
      setShow(false);
      setInputValue("");
    } catch (error) {
      console.error(error);
    }
  };
  //pagination
  const options = {
    sizePerPage: 4,
    hideSizePerPage: true,
    hidePageListOnlyOnePage: true,
    paginationPosition: "bottom",
  };
  //date
  const handleDateChange = (date) => {
    setpublicationDate(date);
  };

  //filtre
  // update filter parameters on change
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilter((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };
  //filtre par date

  // cancel date range filter
  const handleCancelDateRange = () => {
    setFilter((prevState) => ({
      ...prevState,
      startDate: "",
      endDate: "",
    }));
  };
  // update filter on date range change
  const handleDateRangeChange = (event, picker) => {
    setFilter((prevState) => ({
      ...prevState,
      startDate: picker.startDate.format("YYYY-MM-DD"),
      endDate: picker.endDate.format("YYYY-MM-DD"),
    }));
  };
  // filter data
  const filterData = async () => {
    try {
      const response = await campagneService.getCampagnesByFiltre(
        getCurrentUserId(),
        filter.nom,
        filter.canalDiffusion,
        filter.statut,
        filter.startDate,
        filter.endDate
      );
      setData(response.data.success);
      // console.log(response.data.success);
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  //methode pour afficher objectifs
  const AfficherListObjectifs = async () => {
    try {
      const response = await enumListService.AfficherListObjectifs();
      setObjectifsData(response.data.success);
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  //methode pour afficher status
  const AfficherListStatus = async () => {
    try {
      const response = await enumListService.AfficherListStatus();
      setStatutsData(response.data.success);
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };
  //methode pour afficher Canal de Diffusions
  const AfficherListCanalDiffusion = async () => {
    try {
      const response = await enumListService.AfficherListCanalDiffusion();
      setCanalDiffusionsData(response.data.success);
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  //methode pour afficher types
  const AfficherListTypes = async () => {
    try {
      const response = await enumListService.AfficherListTypes();
      setTypesData(response.data.success);
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  //useEffect
  useEffect(() => {
    AfficherListTypes();
    AfficherListCanalDiffusion();
    AfficherListStatus();
    AfficherListObjectifs();
  }, []);
  // useEffect to fetch data based on filter parameters
  useEffect(() => {
    filterData();
  }, [filter]);

  //routes
  const navigate = useNavigate();

  // columns-Campagne
  const columns = [
    {
      dataField: "creationDate",
      text: "Date creation",
      formatter: (cell) => {
        const options = { year: "numeric", month: "2-digit", day: "2-digit" };
        const date = new Date(cell);
        return date.toLocaleDateString("fr-FR", options).replace(/\//g, "-");
      },
    },
    {
      dataField: "nom",
      text: "Nom",
    },
    {
      dataField: "budget",
      text: "Budget",
    },
    {
      dataField: "canalDiffusion",
      text: "Canal Diffusion",
    },
    {
      dataField: "statut",
      text: "Statut",
      formatter: (cellContent, row) => {
        if (row && row.statut === "terminé") {
          return <span className="badge badge-danger">{cellContent}</span>;
        } else {
          return <span className="badge badge-success">{cellContent}</span>;
        }
      },
    },
    {
      dataField: "actions",
      text: "Actions",
      csvExport: false,
      formatter: (cellContent, row) => {
        return (
          <>
            <div className="d-flex justify-content-center">
              <Button
                variant="warning"
                className="mr-2"
                onClick={() => {
                  if (
                    row &&
                    (row.userIdCreation === userId ||
                      (userRoles &&
                        userRoles.includes("RESPONSABLE_MARKETING")) ||
                      (userRoles &&
                        userRoles.includes("RESPONSABLE_MARKETING") &&
                        row.roleUserCreation.includes("COMMUNITY_MANAGER")))
                  ) {
                    if (row && row.canalDiffusion === "Email") {
                      //console.log("Email selected");
                      navigate(`/Campagne/PageCampagneE/Edit/${row.id}`);
                    } else if (row && row.canalDiffusion === "SMS") {
                      //console.log("SMS selected");
                      navigate(`/Campagne/PageCampagneS/Edit/${row.id}`);
                    } else if (row && row.canalDiffusion === "Physique") {
                      // console.log("Physique selected");
                      handleEditCampagnePhysique(row);
                    } else if (
                      row &&
                      (row.canalDiffusion === "Facebook" ||
                        row.canalDiffusion === "LinkedIn" ||
                        row.canalDiffusion === "Instagram")
                    ) {
                      // console.log("Réseaux sociaux selected");
                      handleEditCampagneReseauxSociaux(row);
                    } else {
                      //console.log("Nothing selected");
                    }
                  }
                }}
                disabled={
                  !(
                    row &&
                    (row.userIdCreation === userId ||
                      (userRoles &&
                        userRoles.includes("RESPONSABLE_MARKETING")) ||
                      (userRoles &&
                        userRoles.includes("RESPONSABLE_MARKETING") &&
                        row.roleUserCreation.includes("COMMUNITY_MANAGER")))
                  ) || row.statut === "terminé"
                }
              >
                <i className="fas fa-edit"></i>
              </Button>{" "}
              <Button
                variant="danger"
                className="mr-2"
                onClick={() => {
                  if (
                    row &&
                    (row.userIdCreation === userId ||
                      (userRoles &&
                        userRoles.includes("RESPONSABLE_MARKETING")) ||
                      (userRoles &&
                        userRoles.includes("RESPONSABLE_MARKETING") &&
                        row.roleUserCreation.includes("COMMUNITY_MANAGER")))
                  ) {
                    handleDeleteCampagne(row);
                  }
                }}
                disabled={
                  !(
                    row &&
                    (row.userIdCreation === userId ||
                      (userRoles &&
                        userRoles.includes("RESPONSABLE_MARKETING")) ||
                      (userRoles &&
                        userRoles.includes("RESPONSABLE_MARKETING") &&
                        row.roleUserCreation.includes("COMMUNITY_MANAGER")))
                  ) || row.statut === "terminé"
                }
              >
                <i className="fas fa-trash"></i>
              </Button>
              <Button
                variant="secondary"
                onClick={() => {
                  console.log(row);
                  if (row && row.canalDiffusion === "Email") {
                    //console.log("Email selected");
                    navigate(`/Campagne/PageCampagneE/Voir/${row.id}`);
                  } else if (row && row.canalDiffusion === "SMS") {
                    //console.log("SMS selected");
                    navigate(`/Campagne/PageCampagneS/Voir/${row.id}`);
                  } else if (row && row.canalDiffusion === "Physique") {
                    // console.log("Physique selected");
                    navigate(`/Campagne/PageCampagnePhy/Voir/${row.id}`);
                  } else if (
                    row &&
                    (row.canalDiffusion === "Facebook" ||
                      row.canalDiffusion === "LinkedIn" ||
                      row.canalDiffusion === "Instagram")
                  ) {
                    // console.log("Réseaux sociaux selected");
                    navigate(`/Campagne/PageCampagneR/Voir/${row.id}`);
                  } else {
                    //console.log("Nothing selected");
                  }
                }}
              >
                <i className="fas fa-chart-pie"></i>
              </Button>
            </div>
          </>
        );
      },
    },
  ];
  // /.columns-Campagne
  return (
    <>
      {/* content-header */}
      <div className="content-wrapper" style={{ marginTop: "0" }}>
        <div className="content-header">
          <div className="container-fluid">
            <div className="row mb-2">
              <div className="col-sm-6">
                <h1 className="m-0">Campagne</h1>
              </div>
            </div>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-3 col-6">
                <div className="info-box mb-3 bg-gray">
                  <span className="info-box-icon">
                    <i class="fas fa-flag"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Physique</span>
                    <span className="info-box-number">
                      <Link
                        to={"/Campagne/PageCampagnePhy"}
                        style={{ color: "white" }}
                      >
                        Voir plus
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-6">
                <div className="info-box mb-3 bg-gray">
                  <span className="info-box-icon">
                    <i class="fas fa-envelope"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">Email</span>
                    <span className="info-box-number">
                      <Link
                        to={"/Campagne/PageCampagneE"}
                        style={{ color: "white" }}
                      >
                        Voir plus
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-6">
                <div className="info-box mb-3 bg-gray">
                  <span className="info-box-icon">
                    <i class="fas fa-comments"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text">SMS</span>
                    <span className="info-box-number">
                      <Link
                        to={"/Campagne/PageCampagneS"}
                        style={{ color: "white" }}
                      >
                        Voir plus
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-6">
                <div className="info-box mb-3 bg-gray">
                  <span className="info-box-icon">
                    <i class="fas fa-thumbs-up"></i>
                  </span>
                  <div className="info-box-content">
                    <span className="info-box-text"> Réseaux sociaux</span>
                    <span className="info-box-number">
                      <Link
                        to={"/Campagne/PageCampagneR"}
                        style={{ color: "white" }}
                      >
                        Voir plus
                      </Link>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* /.types of campagne */}

          {/* filtre */}
          <Divider />
          <div className="row mt-2">
            <div className="col-md-12">
              <div className="card-deck">
                <Card className="Campagne-card-filter">
                  <Card.Body>
                    <div className="row">
                      <div className="col-sm-6">
                        <label>Date</label>
                        <div className="input-group date mt-2">
                          <DateRangePicker
                            className="input-group date"
                            startDatePlaceholder="Start Date"
                            endDatePlaceholder="End Date"
                            onApply={handleDateRangeChange}
                          >
                            <div className="input-group">
                              <div className="input-group-prepend">
                                <span className="input-group-text">
                                  <FontAwesomeIcon icon={faCalendarAlt} />
                                </span>
                              </div>
                              <input
                                type="text"
                                className="form-control datetimepicker-input"
                                placeholder="Select Date .."
                                value={
                                  filter.startDate && filter.endDate
                                    ? `${filter.startDate} - ${filter.endDate}`
                                    : ""
                                }
                              />
                              {filter.startDate && filter.endDate && (
                                <div className="input-group-append">
                                  <span className="input-group-text">
                                    <FontAwesomeIcon
                                      icon={faTimes}
                                      onClick={handleCancelDateRange}
                                    />
                                  </span>
                                </div>
                              )}
                            </div>
                          </DateRangePicker>
                        </div>
                      </div>
                      {/* filtre par select Canal de diffusion*/}
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Canal de diffusion</label>
                          <select
                            className="custom-select mt-2"
                            name="canalDiffusion"
                            value={filter.canalDiffusion}
                            onChange={handleFilterChange}
                          >
                            <option value="">All</option>
                            {canalDiffusionsData?.map((canalDiffusion) => (
                              <option
                                key={canalDiffusion}
                                value={canalDiffusion}
                              >
                                {canalDiffusion}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      {/* /.filtre par select Canal de diffusion*/}
                      {/* filtre par statut*/}
                      <div className="col-sm-3">
                        <div className="form-group">
                          <label>Statut</label>
                          <select
                            className="custom-select mt-2"
                            name="statut"
                            value={filter.statut}
                            onChange={handleFilterChange}
                          >
                            <option value="">All</option>
                            {statutsData?.map((statut) => (
                              <option key={statut} value={statut}>
                                {statut}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      {/* /.filtre par statut*/}
                    </div>
                  </Card.Body>
                </Card>
              </div>
            </div>
          </div>

          {/* /.filtre */}

          {/* table */}
          <Divider />
          {success && (
            <div className="alert alert-success" role="alert">
              {success}
            </div>
          )}
          <ToolkitProvider>
            {(props) => (
              <>
                <div className="row mt-2">
                  <div className="col-md-12">
                    <Card className="pb-3">
                      <Card.Body>
                        {/* table-button */}
                        <div className="d-flex justify-content-end align-items-center mb-3">
                          <div className="input-container">
                            {/* SearchData */}
                            <div className="p-2">
                              <div className="input-group">
                                <input
                                  className="form-control "
                                  type="search"
                                  placeholder="Search"
                                  aria-label="Search"
                                  name="nom"
                                  value={filter.nom}
                                  onChange={handleFilterChange}
                                />
                              </div>
                            </div>
                            {/* /.SearchData */}
                            {/* ExportCSV button */}
                            <div className="p-2">
                              <Button
                                onClick={handleExportCSV}
                                variant="dark"
                                className="my-custom-class Exporter input-container"
                              >
                                Exporter CSV
                              </Button>
                            </div>
                            {/* /.ExportCSV button */}
                          </div>
                        </div>
                        {/* /.table-button */}

                        <div className="table-container thead-dark mb-3">
                          <BootstrapTable
                            keyField="id"
                            hover
                            condensed
                            pagination={paginationFactory(options)}
                            defaultSorted={[
                              { dataField: "createdDate", order: "asc" },
                            ]}
                            faultSortDirection="asc"
                            noDataIndication={() => "No data found"}
                            data={data}
                            columns={columns}
                            headerClasses="thead-dark"
                          />
                        </div>

                        {/* DeleteModal */}
                        <Modal show={show} onHide={handleClose} centered>
                          <Modal.Header>
                            <Modal.Title>
                              Confirmation de suppression
                            </Modal.Title>
                            <button className="close">
                              <FontAwesomeIcon
                                icon={faTimes}
                                closeButton
                                onClick={handleClose}
                              />
                            </button>
                          </Modal.Header>
                          <Modal.Body>
                            Êtes-vous sûr(e) de vouloir supprimer ?<br />
                            <br />
                            <strong>Date de creation : </strong>
                            {selectedRow && selectedRow.createdDate && (
                              <>
                                {new Date(selectedRow.createdDate)
                                  .toLocaleDateString("fr-FR", {
                                    year: "numeric",
                                    month: "2-digit",
                                    day: "2-digit",
                                  })
                                  .replace(/\//g, "-")}
                              </>
                            )}
                            <br />
                            <strong>Nom : </strong>
                            {selectedRow && selectedRow.nom}
                            <br />
                            <br />
                            <br />
                            <p>
                              Tapper le mot <strong>DELETE</strong> pour pouvez
                              supprimer Data
                            </p>
                            <input
                              type="text"
                              className="form-control"
                              placeholder="DELETE"
                              value={inputValue}
                              onChange={handleInputChangeDelete}
                            />
                          </Modal.Body>
                          <Modal.Footer>
                            <Button variant="secondary" onClick={handleClose}>
                              Annuler
                            </Button>
                            <Button
                              variant="danger"
                              onClick={handleConfirmDelete}
                              disabled={buttonDisabled}
                            >
                              Supprimer
                            </Button>
                          </Modal.Footer>
                        </Modal>
                        {/* /.DeleteModal */}

                        {/* EditEventModalPhysique */}
                        <Modal
                          show={showModalPhysique}
                          onHide={handleCancelPhysique}
                          size="xl"
                          aria-labelledby="contained-modal-title-vcenter"
                          centered
                        >
                          <div
                            className="card card-dark"
                            style={{ boxShadow: "none", marginBottom: 0 }}
                          >
                            <div className="card-header">
                              <h3 className="card-title">
                                Modifier Campagne Physique
                              </h3>
                              <button className="close">
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  closeButton
                                  onClick={handleCancelPhysique}
                                  style={{ color: "white" }}
                                />
                              </button>
                            </div>
                            <form>
                              <div className="card-body">
                                {erreur && (
                                  <div
                                    className="alert alert-danger"
                                    role="alert"
                                  >
                                    {erreur}
                                  </div>
                                )}

                                <div className="form-group">
                                  <div className="row">
                                    <div className="col">
                                      <div className="form-group">
                                        <label htmlFor="exampleInputEmail1">
                                          Nom
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="exampleInputEmail1"
                                          placeholder="Nom"
                                          name="nom"
                                          value={formData.nom}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                    </div>
                                    <div className="col">
                                      <div className="form-group">
                                        <label htmlFor="exampleInputEmail1">
                                          Budget
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          id="exampleInputEmail1"
                                          placeholder="Budget"
                                          name="budget"
                                          value={formData.budget}
                                          onChange={handleInputChange}
                                        />
                                      </div>
                                    </div>
                                    <div className="col">
                                      <div className="form-group">
                                        <label htmlFor="exampleInputEmail1">
                                          Objectif
                                        </label>
                                        <select
                                          className="custom-select"
                                          id="objectif"
                                          name="objectif"
                                          value={formData.objectif}
                                          onChange={handleInputChange}
                                        >
                                          {objectifsData.map((objectif) => (
                                            <option
                                              key={objectif}
                                              value={objectif}
                                            >
                                              {objectif}
                                            </option>
                                          ))}
                                        </select>
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="form-group">
                                  <div className="row">
                                    <div className="col">
                                      <div className="form-group">
                                        <label htmlFor="exampleInputEmail1">
                                          Date debut and Time:
                                        </label>
                                        <Datetime
                                          onChange={handledebutDateChange}
                                          value={formData.debutDate}
                                          name="debutDate"
                                        />
                                      </div>
                                    </div>
                                    <div className="col">
                                      <div className="form-group">
                                        <label htmlFor="exampleInputEmail1">
                                          Date fin and Time:
                                        </label>
                                        <Datetime
                                          onChange={handlefinDateChange}
                                          value={formData.finDate}
                                          name="finDate"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div class="form-group">
                                  <label htmlFor="exampleInputEmail1">
                                    Adresse
                                  </label>
                                  <div className="row">
                                    <div className="col">
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="exampleInputEmail1"
                                        placeholder="Rue"
                                        name="rue"
                                        value={formData.rue}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                    <div className="col">
                                      <input
                                        type="text"
                                        class="form-control"
                                        id="exampleInputEmail1"
                                        placeholder="Ville"
                                        name="ville"
                                        value={formData.ville}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                    <div className="col">
                                      <input
                                        type="text"
                                        class="form-control"
                                        id="exampleInputEmail1"
                                        placeholder="Pays"
                                        name="pays"
                                        value={formData.pays}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>
                                </div>

                                <div className="form-group">
                                  <label htmlFor="pieces-jointes">
                                    Pieces jointes
                                  </label>
                                  <div className="input-group">
                                    <div className="custom-file">
                                      <input
                                        type="file"
                                        className="custom-file-input"
                                        id="PiecesJoints"
                                        name="PiecesJoints"
                                        onChange={handlePieceJointeChange}
                                        value={formData.PiecesJoints}
                                      />
                                      <label
                                        className="custom-file-label"
                                        htmlFor="pieces-jointes"
                                      >
                                        {piecesJointesdata.length === 0
                                          ? "Choose file"
                                          : piecesJointesdata
                                              .map((fichier) => fichier.name)
                                              .join(", ")}
                                      </label>
                                    </div>
                                    {piecesJointesdata.length > 0 && (
                                      <div className="input-group-append">
                                        <button
                                          className="btn btn-outline-secondary"
                                          type="button"
                                          onClick={handleDeletePieceJointe}
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                  {/* affichage des images  */}
                                  <div className="row mt-3">
                                    {piecesJointesdata.map((fichier, index) => (
                                      <div
                                        key={index}
                                        className="col-sm-3 text-center mb-3"
                                      >
                                        <img
                                          src={URL.createObjectURL(fichier)}
                                          alt={fichier.name}
                                          style={{
                                            width: "100%",
                                            height: "80%",
                                          }}
                                        />
                                        <button
                                          className="btn btn-outline-danger col-sm mt-3 mb-3"
                                          type="button"
                                          onClick={() =>
                                            handleDeletePieceJointe(index)
                                          }
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </div>
                                    ))}
                                  </div>
                                  {/* end of affichage des images  */}
                                </div>
                              </div>
                            </form>
                          </div>
                          <div className="card-footer text-right">
                            <button
                              type="button"
                              className="btn btn-secondary mr-2"
                              onClick={handleCancelPhysique}
                            >
                              Annuler
                            </button>
                            <button
                              type="submit"
                              className="btn btn-dark"
                              onClick={handleUpdateCampagnePhysique}
                            >
                              Modifier
                            </button>
                          </div>
                        </Modal>
                        {/* /.EditEventModalPhysique */}

                        {/* EditEventModalReseaux */}
                        <Modal
                          show={showModalReseaux}
                          onHide={handleCancelCampagneReseauxSociaux}
                          size="xl"
                          aria-labelledby="contained-modal-title-vcenter"
                          centered
                        >
                          <div
                            className="card card-dark"
                            style={{ boxShadow: "none", marginBottom: 0 }}
                          >
                            <div className="card-header">
                              <h3 className="card-title">Modifier Campagne</h3>
                              <button className="close">
                                <FontAwesomeIcon
                                  icon={faTimes}
                                  closeButton
                                  onClick={handleCancelCampagneReseauxSociaux}
                                  style={{ color: "white" }}
                                />
                              </button>
                            </div>
                            <form>
                              <div className="card-body">
                                {erreur && (
                                  <div
                                    className="alert alert-danger"
                                    role="alert"
                                  >
                                    {erreur}
                                  </div>
                                )}

                                <div className="form-group">
                                  <label htmlFor="exampleInputEmail1">
                                    Nom
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control"
                                    id="exampleInputEmail1"
                                    placeholder="Nom"
                                    name="nom"
                                    value={formData.nom}
                                    onChange={handleInputChange}
                                  />
                                </div>
                                <div className="form-group">
                                  <label htmlFor="exampleInputEmail1">
                                    Objectif
                                  </label>
                                  <select
                                    className="custom-select"
                                    id="objectif"
                                    name="objectif"
                                    value={formData.objectif}
                                    onChange={handleInputChange}
                                  >
                                    {objectifsData.map((objectif) => (
                                      <option key={objectif} value={objectif}>
                                        {objectif}
                                      </option>
                                    ))}
                                  </select>
                                </div>

                                <div className="form-group">
                                  <div className="row">
                                    <div className="col">
                                      <label htmlFor="exampleInputEmail1">
                                        Canal de diffusion
                                      </label>
                                      <select
                                        className="custom-select"
                                        id="canalDiffusion"
                                        name="canalDiffusion"
                                        value={formData.canalDiffusion}
                                        onChange={handleInputChange}
                                      >
                                        {canalDiffusionsData.map(
                                          (canalDiffusion) => (
                                            <option
                                              key={canalDiffusion}
                                              value={canalDiffusion}
                                            >
                                              {canalDiffusion}
                                            </option>
                                          )
                                        )}
                                      </select>
                                    </div>
                                    <div className="col">
                                      <label htmlFor="exampleInputEmail1">
                                        Type
                                      </label>
                                      <select
                                        className="custom-select"
                                        id="type"
                                        name="type"
                                        value={formData.type}
                                        onChange={handleInputChange}
                                      >
                                        {typesData.map((type) => (
                                          <option key={type} value={type}>
                                            {type}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div>
                                </div>

                                <div className="form-group">
                                  <label htmlFor="exampleInputEmail1">
                                    Contenu
                                  </label>
                                  <textarea
                                    className="form-control"
                                    rows="3"
                                    placeholder="Contenu ..."
                                    name="contenu"
                                    value={formData.contenu}
                                    onChange={handleInputChange}
                                  ></textarea>
                                </div>

                                <div className="form-group">
                                  <div className="row">
                                    <div className="col">
                                      <label htmlFor="exampleInputEmail1">
                                        Cible
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        id="exampleInputEmail1"
                                        placeholder="Cible"
                                        name="cible"
                                        value={formData.cible}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                    <div className="col">
                                      <div className="form-group">
                                        <label htmlFor="exampleInputEmail1">
                                          Date Publication:
                                        </label>
                                        <Datetime
                                          onChange={handleDateChange}
                                          value={formData.publicationDate}
                                          name="publicationDate"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="form-group">
                                  <label htmlFor="pieces-jointes">
                                    Pieces jointes
                                  </label>
                                  <div className="input-group">
                                    <div className="custom-file">
                                      <input
                                        type="file"
                                        className="custom-file-input"
                                        id="PiecesJoints"
                                        name="PiecesJoints"
                                        onChange={handlePieceJointeChange}
                                        value={formData.PiecesJoints}
                                      />
                                      <label
                                        className="custom-file-label"
                                        htmlFor="pieces-jointes"
                                      >
                                        {piecesJointesdata.length === 0
                                          ? "Choose file"
                                          : piecesJointesdata
                                              .map((fichier) => fichier.name)
                                              .join(", ")}
                                      </label>
                                    </div>
                                    {piecesJointesdata.length > 0 && (
                                      <div className="input-group-append">
                                        <button
                                          className="btn btn-outline-secondary"
                                          type="button"
                                          onClick={handleDeletePieceJointe}
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </div>
                                    )}
                                  </div>
                                  {/* affichage des images  */}
                                  <div className="row mt-3">
                                    {piecesJointesdata.map((fichier, index) => (
                                      <div
                                        key={index}
                                        className="col-sm-3 text-center mb-3"
                                      >
                                        <img
                                          src={URL.createObjectURL(fichier)}
                                          alt={fichier.name}
                                          style={{
                                            width: "100%",
                                            height: "80%",
                                          }}
                                        />
                                        <button
                                          className="btn btn-outline-danger col-sm mt-3 mb-3"
                                          type="button"
                                          onClick={() =>
                                            handleDeletePieceJointe(index)
                                          }
                                        >
                                          <i className="fa fa-trash"></i>
                                        </button>
                                      </div>
                                    ))}
                                  </div>
                                  {/* end of affichage des images  */}
                                </div>
                              </div>
                            </form>
                          </div>
                          <div className="card-footer text-right">
                            <button
                              type="button"
                              className="btn btn-secondary mr-2"
                              onClick={handleCancelCampagneReseauxSociaux}
                            >
                              Annuler
                            </button>
                            <button
                              type="submit"
                              className="btn btn-dark"
                              onClick={handleUpdateCampagneReseauxSociaux}
                            >
                              Modifier
                            </button>
                          </div>
                        </Modal>
                        {/* /.EditEventModalReseaux */}
                      </Card.Body>
                    </Card>
                  </div>
                </div>
                {/* /.table */}
              </>
            )}
          </ToolkitProvider>

          {/* /.container-fluid */}
        </section>
        {/* /.content */}
      </div>
    </>
  );
}

export default PageCampagne;
